var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFtljstandard01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 101.93 104.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "-9.29 111.15 110.35 111.15 110.35 -18.21 -9.29 -18.21 -9.29 111.15"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "20.8 30.12 80.44 30.12 80.44 88.92 20.8 88.92 20.8 30.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "20.8 13.32 80.44 13.32 80.44 21.72 20.8 21.72 20.8 13.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "20.8 84.72 12.82 84.72 12.82 13.32 20.8 13.32 20.8 84.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "80.44 84.72 88.42 84.72 88.42 13.32 80.44 13.32 80.44 84.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "20.8 21.72 80.44 21.72 80.44 30.12 20.8 30.12 20.8 21.72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtljstandard01);
export default __webpack_public_path__ + "static/media/Fåtölj standard-01.5e8718a7abacec8f58a7035b449f4681.svg";
export { ForwardRef as ReactComponent };